import * as React from 'react';
import { Input, message } from 'antd';
import storageUtils from '@/utils/storageUtils';
import config from '@/config/config';
import Urls from '@/config/url';
import https from '@/utils/ajaxUtils';
import RegularUtils from '@/utils/regularUtils';
const { TextArea } = Input;
class ContactUs extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      token: JSON.parse(storageUtils.get(config.loginStorageKey)),
      param: {
        name: null,
        tel: null,
        email: null,
        message: null,
        userId: null,
        type: 'contact'
      },
      loadding: false
    };
  }
  UNSAFE_componentWillMount() {
    // console.log(this.state.token);
    if (this.state.token && this.state.token.loginInfo && this.state.token.loginInfo.userInfo) {
      let param = this.state.param;
      let userInfo = this.state.token.loginInfo.userInfo;
      // console.log('userInfo: ', userInfo);
      param.userId = userInfo.uuid;
      param.name = userInfo.username;
      param.tel = userInfo.mobile;
      param.email = userInfo.email;
      this.setState({
        ...param
      }, () => {
        // console.log(this.state.param);
      });
    }
  }
  dataChange = (value, type) => {
    let param = this.state.param;
    if (type === 'name') {
      param.name = value;
    }
    if (type === 'tel') {
      param.tel = value;
    }
    if (type === 'email') {
      param.email = value;
    }
    if (type === 'message') {
      param.message = value;
    }
    this.setState({ param }, () => {
      // console.log(this.state.param);
    });
  }
  commit = async () => {
    let param = this.state.param;
    if (!param.name || !param.tel || !param.email || !param.message) {
      message.error('请完善信息!');
      return;
    }
    console.log(RegularUtils.is_mobile(param.tel));
    if (!RegularUtils.is_mobile(param.tel)) {
      message.error('请输入正确的手机号码!');
      return;
    }
    if (!RegularUtils.checkEmail(param.email)) {
      message.error('请输入正确的邮箱!');
      return;
    }
    console.log('param: ', param);
    this.setState({ loadding: true });
    const res = await https.post(Urls.addFeedback, param);
    this.setState({ loadding: false });
    console.log('res: ', res);
    if (!res.success) {
      message.error('提交失败!' + res.errMsg);
      return;
    }
    message.success('感谢您的宝贵意见，我们会认真对待!');
    let newparam = {
      name: null,
      tel: null,
      email: null,
      message: null,
      userId: null,
      type: 'contact'
    }
    this.setState({ param: newparam });
  }
  render() {
    // console.log('登录信息:', this.state.token);
    return (
      <React.Fragment>
        <div className="top-img">
          <img src="/img/contact-us-top-img.png" alt="" />
          {/* <div className="page-name">联系我们</div> */}
        </div>
        <div className="index-content">
          <div className="contact-us-title">如果您对本产品有更好改进建议，请务必尽快联系我们！</div>
          <div className="form m25">
            <div className="form-item">
              <div className="label"><span className="red">*</span>您的姓名：</div>
              <div className="input">
                <Input placeholder="方便我们称呼您" value={this.state.param.name} onChange={(e) => { this.dataChange(e.target.value, 'name') }} />
              </div>
            </div>
            <div className="form-item">
              <div className="label"><span className="red">*</span>您的电话：</div>
              <div className="input">
                <Input placeholder="方便我们联系您" value={this.state.param.tel} onChange={(e) => { this.dataChange(e.target.value, 'tel') }} />
              </div>
            </div>
            <div className="form-item">
              <div className="label"><span className="red">*</span>您的邮箱：</div>
              <div className="input">
                <Input placeholder="在您不方便时，我们会回复您邮件" value={this.state.param.email} onChange={(e) => { this.dataChange(e.target.value, 'email') }} />
              </div>
            </div>
            <div className="form-item high">
              <div className="label"><span className="red">*</span>建议或意见：</div>
              <div className="input">
                {/* <TextArea placeholder="真诚感谢您的宝贵意见"></TextArea> */}
                <TextArea
                  maxLength={1000}
                  showCount
                  value={this.state.param.message}
                  onChange={(v) => { this.dataChange(v.target.value, 'message') }}
                  placeholder="真诚感谢您的宝贵意见"
                  autoSize={{ minRows: 3, maxRows: 5 }}
                />
              </div>
            </div>
            {
              !this.state.loadding &&
              <div className="action" onClick={() => { this.commit() }}>
                <div className="button" >确定</div>
              </div>
            }
            {
              this.state.loadding &&
              <div className="action">
                <div className="button gray">确定</div>
              </div>
            }
          </div>
        </div>

      </React.Fragment>
    );
  }
}

export default ContactUs;
